import React from 'react';
import { Handle, Position, useReactFlow } from 'reactflow';
import ConfirmDialog from '../overlays/ConfirmDialog';

const methodColors = {
    GET:    { bg:'#dbeafe', color:'#1565c0' },
    POST:   { bg:'#dcfce7', color:'#16a34a' },
    PUT:    { bg:'#fef9c3', color:'#ca8a04' },
    PATCH:  { bg:'#f3e8ff', color:'#7c3aed' },
    DELETE: { bg:'#fee2e2', color:'#dc2626' },
};

function APINode({ id, data, selected }) {
    const { setNodes, setEdges } = useReactFlow();
    const [showDelete, setShowDelete] = React.useState(false);
    const api    = data?.api || {};
    const method = api.method || 'GET';
    const mc     = methodColors[method] || { bg:'#f3f4f6', color:'#6b7280' };

    const confirmDelete = () => {
        setShowDelete(false);
        setNodes(n => n.filter(x => x.id !== id));
        setEdges(e => e.filter(x => x.source !== id && x.target !== id));
    };

    return (
        <div style={{ width:210, background:'#fff', border:`2px solid ${selected ? '#7c3aed' : '#e5e7eb'}`, borderRadius:10, boxShadow:'0 2px 8px rgba(0,0,0,0.08)', overflow:'hidden' }}>
            <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', padding:'7px 10px', background:'linear-gradient(to right, #7c3aed, #6d28d9)' }}>
                <div style={{ display:'flex', alignItems:'center', gap:6, color:'#fff', fontSize:11, fontWeight:700 }}>
                    <i className="bi bi-globe" style={{ fontSize:12 }}></i> API Connector
                </div>
                <button onClick={e => { e.stopPropagation(); setShowDelete(true); }} style={btnStyle}>
                    <i className="bi bi-x" style={{ fontSize:12 }}></i>
                </button>
            </div>
            <div style={{ padding:'8px 10px', display:'flex', flexDirection:'column', gap:4 }}>
                <div style={{ display:'flex', alignItems:'center', gap:6 }}>
                    <span style={{ fontSize:10, fontWeight:700, padding:'2px 6px', borderRadius:4, background:mc.bg, color:mc.color }}>{method}</span>
                    {data.retryCount > 0 && <span style={{ fontSize:10, color:'#9ca3af' }}>retry:{data.retryCount}</span>}
                </div>
                <p style={{ fontSize:10, color:'#6b7280', overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap', margin:0 }}>{api.url || 'No URL set'}</p>
                {data.happyPathMessage && <p style={{ fontSize:10, color:'#16a34a', overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap', margin:0 }}>✓ {data.happyPathMessage.slice(0,40)}</p>}
                {data.failoverMessage  && <p style={{ fontSize:10, color:'#dc2626', overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap', margin:0 }}>✗ {data.failoverMessage.slice(0,40)}</p>}
            </div>
            <Handle id="a" type="target" position={Position.Left} style={hs('#7c3aed')}/>
            <Handle id="b" type="source" position={Position.Right} style={hs('#7c3aed')}/>
            {showDelete && <ConfirmDialog message="Delete this node?" onConfirm={confirmDelete} onCancel={() => setShowDelete(false)}/>}
        </div>
    );
}

const btnStyle = { background:'none', border:'none', cursor:'pointer', color:'rgba(255,255,255,0.8)', padding:2, display:'flex', alignItems:'center' };
const hs = (color) => ({ width:10, height:10, background:color, border:'2px solid #fff', borderRadius:'50%' });

export default APINode;
